var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.errFlag)?_c('div',[_vm._v(" "+_vm._s(_vm.errMsg)+" ")]):_vm._e(),(_vm.type === 'normal')?_c(_vm.normal,{tag:"component"},[_vm._v("1")]):_vm._e(),(_vm.type === 'normal')?_c(_vm.normal,{tag:"component"},[_vm._v("1")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }